let audioCtx: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  const Ctor =
    window.AudioContext ||
    (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  if (!audioCtx) audioCtx = new Ctor();
  if (audioCtx.state === 'suspended') {
    void audioCtx.resume();
  }
  return audioCtx;
}

const MUTE_KEY = 'pos:sound:muted';

export function isSoundMuted(): boolean {
  if (typeof window === 'undefined') return true;
  return localStorage.getItem(MUTE_KEY) === '1';
}

export function setSoundMuted(muted: boolean): void {
  if (typeof window === 'undefined') return;
  if (muted) localStorage.setItem(MUTE_KEY, '1');
  else localStorage.removeItem(MUTE_KEY);
}

type ToneType = 'sine' | 'square' | 'sawtooth' | 'triangle';

function playTone(
  ctx: AudioContext,
  frequency: number,
  startOffset: number,
  duration: number,
  type: ToneType,
  peak: number,
) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  const now = ctx.currentTime + startOffset;

  osc.type = type;
  osc.frequency.setValueAtTime(frequency, now);

  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(peak, now + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);

  osc.connect(gain);
  gain.connect(ctx.destination);

  osc.start(now);
  osc.stop(now + duration + 0.05);
}

export function playAddSound(): void {
  if (isSoundMuted()) return;
  const ctx = getAudioContext();
  if (!ctx) return;
  playTone(ctx, 760, 0, 0.09, 'sine', 0.2);
}

export function playSaleSound(): void {
  if (isSoundMuted()) return;
  const ctx = getAudioContext();
  if (!ctx) return;
  // "ka-ching": golpe metálico seguido de un repique ascendente.
  playTone(ctx, 520, 0, 0.08, 'triangle', 0.22);
  playTone(ctx, 780, 0.07, 0.1, 'triangle', 0.2);
  playTone(ctx, 1040, 0.14, 0.14, 'triangle', 0.18);
  playTone(ctx, 1560, 0.2, 0.22, 'sine', 0.12);
}